import TextArea from 'antd/es/input/TextArea';
import MyInput from '../../../components/ui/MyInput';
import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Radio, RadioGroup } from '@nextui-org/react';

const AppDetails = ({ appDetailsFormButtonRef, data, setData, onSave }) => {
  const app = useSelector(state => state.myAppsSlice?.localReduxData.app);
  const initialAppDetailsData = {
    mobileAppName: app?.mobileAppName,
    googlePlayShortDesc: '',
    appStoreShortDesc: '',
    keywords: [],
    description: '',
    category: '',
    copyright: '',
    isChildrenContent: false,
    appLogo: app?.appLogo,
    ageLimit: '',
    privacyPolicySelectedOption: '',
    customPrivacyPolicy: '',
    isLocation: false,
    isPersonalInformation: false,
    isPhotos: false,
    isMicrophone: false,
    isCamera: false,
    isStorage: false,
    countrySelectedOption: '',
    publishCountry: '',
    isGooglePlayGameServices: false,
    isAdId: false,
    isAtt: false,
    isAppleSignInHelp: false,
    facebookAppId: '',
    facebookClientToken: '',
    // supportEmail: '',

    // supportPhoneNumber: '',

    // ageLimit: '',
    // googlePlayPlaceholder: '',
    // splashScreen: '',
    // placeholderImage: '',
    // storePreviewImages: [],
  };
  const [appDetailsData, setAppDetailsData] = useState(initialAppDetailsData);

  const updateAppDetails = (key, value) => {
    setAppDetailsData(state => ({ ...state, [key]: value }));
  };

  useEffect(() => {
    const newAppDetailsData = { ...initialAppDetailsData };
    Object.keys(data).map(key => {
      if (key in initialAppDetailsData && data[key]) {
        newAppDetailsData[key] = data[key];
      }
    });

    setAppDetailsData(newAppDetailsData);
  }, []);

  return (
    <form
      className="flex flex-col gap-[20px] items-center"
      onSubmit={e => {
        e.preventDefault();
        e.stopPropagation();
        setData(state => ({ ...state, ...appDetailsData }));
        onSave();
      }}
    >
      <div className="bg-white p-4 rounded-lg shadow-xl w-[99%] mb-6">
        <div id="basic-information">
          <div className="section-header bg-slate-50 border-b-2 border-slate-200 p-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-900">📱 Temel Bilgiler</h2>
            <p className="text-gray-600 mt-2">
              Bu bölümdeki bilgiler, uygulamanızın mağazalardaki görünürlüğünü ve bulunabilirliğini doğrudan etkiler.
              Her alanı dikkatle doldurun.
            </p>
          </div>

          <div className="mb-6">
            <div className="w-full">
              <MyInput
                value={appDetailsData.mobileAppName}
                onChange={e => updateAppDetails('mobileAppName', e)}
                maxLength={30}
                isLengthActive
                isRequired={true}
                label={
                  <div>
                    Uygulama Adı <span className="text-red-500">*</span>
                  </div>
                }
                tooltip={
                  <>
                    • Benzersiz ve akılda kalıcı bir isim seçin
                    <br />
                    • Store'larda benzer isimlerde uygulama olup olmadığını kontrol edin
                    <br />
                    • SEO için anahtar kelimenizi ada ekleyin
                    <br />• Türkçe karakter kullanımına dikkat edin
                  </>
                }
                placeholder="Uygulamanızın adı (max 30 karakter)"
              />
            </div>
            <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600">
              <p className="font-medium">💡 Neden Önemli?</p>
              <ul className="list-disc ml-4 mt-1">
                <li>App Store'da aramalarda ilk gösterilen bilgi</li>
                <li>Kullanıcıların %65'i arama yoluyla uygulama buluyor</li>
                <li>Doğru seçilmiş isim, organik indirmeleri %10-20 artırabilir</li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div className="w-full justify-between flex flex-row ">
            <div className="w-[48%]">
              <MyInput
                value={appDetailsData.googlePlayShortDesc}
                onChange={e => updateAppDetails('googlePlayShortDesc', e)}
                maxLength={30}
                isLengthActive
                isRequired={true}
                label={
                  <div>
                    Kısa Açıklama (Google Play) <span className="text-red-500">*</span>
                  </div>
                }
                placeholder="Google Play kısa açıklama (30 karakter)"
                tooltip={
                  <>
                    • Google Play: 30 karakter
                    <br />
                    • Ana değer teklifinizi vurgulayın
                    <br />• Anahtar kelimeleri akıllıca yerleştirin
                  </>
                }
              />
            </div>
            <div className="w-[48%]">
              <MyInput
                value={appDetailsData.appStoreShortDesc}
                onChange={e => updateAppDetails('appStoreShortDesc', e)}
                maxLength={30}
                isLengthActive
                isRequired={true}
                label={
                  <div>
                    Kısa Açıklama (App Store) <span className="text-red-500">*</span>
                  </div>
                }
                placeholder="App Store kısa açıklama (30 karakter)"
                tooltip={
                  <>
                    • App Store: 30 karakter
                    <br />
                    • Ana değer teklifinizi vurgulayın
                    <br />• Anahtar kelimeleri akıllıca yerleştirin
                  </>
                }
              />
            </div>
          </div>
          <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600 mb-6">
            <p className="font-medium">🎯 Etkili Kısa Açıklama İpuçları:</p>
            <ul className="list-disc ml-4 mt-1">
              <li>Ana fayda veya özelliği ilk cümlede belirtin</li>
              <li>Rakiplerden farkınızı vurgulayın</li>
              <li>Çağrı ifadeleri kullanın (Hemen İndir, Keşfet vb.)</li>
            </ul>
          </div>
        </div>

        <div className="w-full">
          <div className="flex flex-col w-full">
            <label className={`flex mb-2 text-sm font-medium text-gray-900`}>
              Detaylı Açıklama <span className="text-red-500 ml-1">*</span>
              <div className="relative group cursor-pointer ml-1">
                <svg
                  fill="#3A80F6"
                  width="20px"
                  height="20px"
                  viewBox="0 0 12.8 12.8"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5-e</title>
                  <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                </svg>
                <div className="absolute bottom-full mb-1  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                  • İlk paragraf en önemli
                  <br />
                  • Özelliklerinizi maddeler halinde sıralayın
                  <br />
                  • Emoji kullanımı dikkat çeker
                  <br />
                  •Güncellemelerde neler değişti belirtin
                </div>
              </div>
            </label>
            <TextArea
              value={appDetailsData.description}
              onChange={e => updateAppDetails('description', e.target.value)}
              required
              showCount
              rows={6}
              maxLength={4000}
              placeholder="Uygulamanızın detaylı açıklaması..."
              classes={'w-[500px]'}
            />
          </div>
          <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600  mb-6">
            <p className="font-medium">📝 Başarılı Bir Açıklama İçin:</p>
            <ul className="list-disc ml-4 mt-1">
              <li>İlk 2-3 cümle kritik - en önemli özellikleri burada belirtin</li>
              <li>Anahtar özellikleri madde madde sıralayın</li>
              <li>Sorun-Çözüm formatını kullanın</li>
              <li>Sosyal kanıt ekleyin (kullanıcı sayısı, değerlendirmeler vb.)</li>
            </ul>
          </div>
        </div>

        <div>
          <div className="w-full flex flex-row justify-between">
            <div className="flex flex-col w-[48%]">
              <label className={`flex mb-2 text-sm font-medium text-gray-900`}>
                Kategori <span className="text-red-500 ml-1">*</span>
                <div className="relative group cursor-pointer ml-1">
                  <svg
                    fill="#3A80F6"
                    width="20px"
                    height="20px"
                    viewBox="0 0 12.8 12.8"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>ionicons-v5-e</title>
                    <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                  </svg>
                  <div className="absolute bottom-full mb-1  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                    Doğru kategori seçimi, hedef kitlenize ulaşmanızı kolaylaştırır
                  </div>
                </div>
              </label>
              <Dropdown
                filter
                value={appDetailsData.category}
                required
                onChange={e => {
                  updateAppDetails('category', e.value);
                }}
                options={categories}
                optionLabel="label"
                className="w-full h-[45px]"
                placeholder="Kategori Seçiniz"
              />
            </div>
            <div className="flex flex-col w-[48%]">
              <MyInput
                value={appDetailsData.keywords}
                onChange={e => updateAppDetails('keywords', e)}
                className=""
                maxLength={100}
                isLengthActive={true}
                label={
                  <div>
                    Anahtar Kelimeler <span className="text-red-500">*</span>
                  </div>
                }
                placeholder="Virgülle ayırarak anahtar kelimeleri girin"
                classes={'w-full'}
                isRequired={true}
                tooltip={<>Özellikle App Store'da arama sonuçlarında önemli rol oynar</>}
              />
            </div>
          </div>
          <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600  mb-6">
            <p className="font-medium">🎯 ASO (App Store Optimization) İpuçları:</p>
            <ul className="list-disc ml-4 mt-1">
              <li>Doğru kategori seçimi görünürlüğü artırır</li>
              <li>Anahtar kelimeleri başlık ve açıklamalarda da kullanın</li>
              <li>Rakip uygulamaların anahtar kelimelerini analiz edin</li>
            </ul>
          </div>
        </div>

        <div className="w-full ">
          <div>
            <div className="w-full mb-6">
              <MyInput
                value={appDetailsData.copyright}
                onChange={e => updateAppDetails('copyright', e)}
                isRequired={true}
                label={
                  <div>
                    Telif Hakkı Metni<span className="text-red-500 ml-1">*</span>
                  </div>
                }
                placeholder="Marka İsmi - Tüm Hakları Saklıdır © 2024"
              />
            </div>
          </div>

          <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600">
            <p className="font-medium">ℹ️ Telif Hakları Hakkında İpuçları:</p>
            <ul className="list-disc ml-4 mt-1 space-y-2">
              <li>
                Şirket adı ve yılı (örn: © 2025 Mobligo) belirtilmeli. “Tüm hakları saklıdır” gibi yasal ibareler
                eklenmeli.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-xl w-[99%] mb-2">
        <div id="policies-information">
          <div className="section-header bg-slate-50 border-b-2 border-slate-200 p-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-900">📋 İçerik ve Politikalar</h2>
            <p className="text-gray-600 mt-2">
              Bu bölüm, uygulamanızın yasal uyumluluğunu ve kullanıcı güvenliğini sağlar. Eksik veya yetersiz
              politikalar en yaygın ret nedenidir.
            </p>
          </div>

          <div className="mb-6">
            <div className="mb-6 text-xl">Yaş Sınırı ve Hedef Kitle</div>
            <div className="flex flex-row justify-between ">
              <div className="flex flex-col w-[48%]">
                <label className={`flex mb-2 text-sm font-medium text-gray-900`}>
                  Yaş Sınırı
                  <span className="text-red-500 ml-1">*</span>
                  <div className="relative group cursor-pointer ml-1">
                    <svg
                      fill="#3A80F6"
                      width="20px"
                      height="20px"
                      viewBox="0 0 12.8 12.8"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>ionicons-v5-e</title>
                      <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                    </svg>
                    <div className="absolute bottom-full mb-1  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                      Yanlış seçim, uygulamanızın hedef kitlenize gösterilmemesine neden olabilir
                    </div>
                  </div>
                </label>
                <Dropdown
                  filter
                  value={appDetailsData.ageLimit}
                  required
                  onChange={e => {
                    updateAppDetails('ageLimit', e.value);
                  }}
                  options={ageLimits}
                  optionLabel="label"
                  className="w-full h-[45px]"
                  placeholder="Yaş Sınırı Seçin"
                />
              </div>
              <div className="flex flex-col w-[48%]">
                <label className={`block mb-2 text-sm font-medium text-gray-900`}>Hedef Kitle</label>
                <div className="flex flex-col">
                  <div className="flex flex-col gap-[20px]">
                    <Checkbox
                      isSelected={appDetailsData.isChildrenContent}
                      value={appDetailsData.isChildrenContent}
                      onChange={() => updateAppDetails('isChildrenContent', !appDetailsData.isChildrenContent)}
                      color="secondary"
                    >
                      Çocuklara yönelik içerik var
                    </Checkbox>
                  </div>
                  <div className="info-box mt-8 bg-orange-50 border-l-4 border-orange-500 p-4 text-sm text-slate-600  mb-6">
                    <p className="font-medium">
                      ⚠️ Çocuklara yönelik uygulamalar COPPA (ABD) ve GDPR-K (AB) uyumlu olmalıdır. Veri toplama
                      politikanızı buna göre düzenlemelisiniz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-6">
              <div className="flex align-items mb-6 text-xl">
                Gizlilik Politikası
                <div className="relative  group cursor-pointer ml-1">
                  <svg
                    fill="#3A80F6"
                    width="24px"
                    height="24px"
                    viewBox="0 0 12.8 12.8"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>ionicons-v5-e</title>
                    <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                  </svg>
                  <div className="absolute bottom-full mb-1  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                    Eksik veya yetersiz gizlilik politikası, en yaygın red nedenidir
                  </div>
                </div>
              </div>
              <div className="space-y-4">
                <RadioGroup
                  value={appDetailsData?.privacyPolicySelectedOption}
                  onChange={e => updateAppDetails('privacyPolicySelectedOption', e.target.value)}
                >
                  <Radio value="mobligo">Mobligo'nun hazır gizlilik politikasını kullan</Radio>
                  <Radio value="custom">Kendi gizlilik politikamı kullanacağım</Radio>
                </RadioGroup>

                {appDetailsData?.privacyPolicySelectedOption === 'custom' && (
                  <div className="ml-6 mt-2">
                    <input
                      type="url"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Gizlilik Politikası URL'si"
                      required
                      onChange={e => updateAppDetails('customPrivacyPolicy', e.target.value)}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600">
              <p className="font-medium">📝 Gizlilik Politikası Kontrol Listesi:</p>
              <ul className="list-disc ml-4 mt-1">
                <li>Toplanan verilerin açık listesi</li>
                <li>Verilerin nasıl kullanıldığı</li>
                <li>Üçüncü taraflarla veri paylaşımı detayları</li>
                <li>Kullanıcı hakları ve veri silme prosedürleri</li>
                <li>GDPR ve CCPA uyumluluk açıklamaları</li>
              </ul>
            </div>
          </div>

          <div className="mb-6">
            <div className="flex mb-6 text-xl">
              Veri Güvenliği Beyanı
              <div className="relative  group cursor-pointer ml-1">
                <svg
                  fill="#3A80F6"
                  width="24px"
                  height="24px"
                  viewBox="0 0 12.8 12.8"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5-e</title>
                  <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                </svg>
                <div className="absolute bottom-full mb-1  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                  Sadece gerçekten ihtiyacınız olan verilere erişim isteyin
                </div>
              </div>
            </div>

            <div className="mb-6">
              <div className="flex flex-row justify-around gap-[20px]">
                <div className="w-[200px]">
                  <Checkbox
                    isSelected={appDetailsData.isLocation}
                    value={appDetailsData.isLocation}
                    onChange={() => updateAppDetails('isLocation', !appDetailsData.isLocation)}
                    color="secondary"
                  >
                    Konum
                  </Checkbox>
                </div>
                <div className="w-[200px]">
                  <Checkbox
                    isSelected={appDetailsData.isPersonalInformation}
                    value={appDetailsData.isPersonalInformation}
                    onChange={() => updateAppDetails('isPersonalInformation', !appDetailsData.isPersonalInformation)}
                    color="secondary"
                  >
                    Kişi Bilgileri
                  </Checkbox>
                </div>
                <div className="w-[200px]">
                  <Checkbox
                    isSelected={appDetailsData.isPhotos}
                    value={appDetailsData.isPhotos}
                    onChange={() => updateAppDetails('isPhotos', !appDetailsData.isPhotos)}
                    color="secondary"
                  >
                    Fotoğraflar
                  </Checkbox>
                </div>
              </div>
            </div>
            <div className="mb-6">
              <div className="flex flex-row justify-around gap-[20px]">
                <div className="w-[200px]">
                  <Checkbox
                    isSelected={appDetailsData.isMicrophone}
                    value={appDetailsData.isMicrophone}
                    onChange={() => updateAppDetails('isMicrophone', !appDetailsData.isMicrophone)}
                    color="secondary"
                  >
                    Mikrofon
                  </Checkbox>
                </div>
                <div className="w-[200px]">
                  <Checkbox
                    isSelected={appDetailsData.isCamera}
                    value={appDetailsData.isCamera}
                    onChange={() => updateAppDetails('isCamera', !appDetailsData.isCamera)}
                    color="secondary"
                  >
                    Kamera
                  </Checkbox>
                </div>

                <div className="w-[200px]">
                  <Checkbox
                    isSelected={appDetailsData.isStorage}
                    value={appDetailsData.isStorage}
                    onChange={() => updateAppDetails('isStorage', !appDetailsData.isStorage)}
                    color="secondary"
                  >
                    Depolama
                  </Checkbox>
                </div>
              </div>
            </div>
            <div className="info-box mt-8 bg-orange-50 border-l-4 border-orange-500 p-4 text-sm text-slate-600  mb-6">
              <p className="font-medium">⚠️ Önemli Hatırlatma:</p>
              <ul className="list-disc ml-4 mt-1">
                <li>Her veri erişimi için kullanıcıya açık bir fayda sunmalısınız</li>
                <li>Gereksiz veri erişimi istekleri uygulamanızın reddedilmesine neden olabilir</li>
                <li>iOS 14.5+ için ATT (App Tracking Transparency) zorunludur</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-xl w-[99%] mb-2">
        <div id="Region-information">
          <div className="section-header bg-slate-50 border-b-2 border-slate-200 p-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-900">🌍 Bölge</h2>
            <p className="text-gray-600 mt-2">
              Bu bölüm, uygulamanızın hangi coğrafi bölgelerde yayınlanacağını ve o bölgelere ait yasal gerekliliklerle
              uyumluluğunu belirler. Yanlış veya eksik bölge seçimi, yayınlama sürecinde sorunlara yol açabilir.
            </p>
          </div>

          <div className="mb-6">
            <div className="mb-6 text-xl">Ülke/Bölge Seçimi</div>
            <div className="mb-6">
              <div className="space-y-4">
                <RadioGroup
                  value={appDetailsData?.countrySelectedOption}
                  onChange={e => updateAppDetails('countrySelectedOption', e.target.value)}
                  isRequired
                >
                  <Radio value="allCountries">Tüm Ülkelerde Yayınla</Radio>
                  <Radio value="custom">Seçili Ülkede Yayınla</Radio>
                </RadioGroup>

                {appDetailsData?.countrySelectedOption === 'custom' && (
                  <Dropdown
                    filter
                    value={appDetailsData.publishCountry}
                    required
                    onChange={e => {
                      updateAppDetails('publishCountry', e.value);
                    }}
                    options={countries}
                    optionLabel="label"
                    className="w-full h-[45px]"
                    placeholder="Ülke Seçiniz"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="info-box mt-8 bg-orange-50 border-l-4 border-orange-500 p-4 text-sm text-slate-600  mb-6">
            <p className="font-medium">⚠️ Bölgesel Gereksinimler:</p>
            <ul className="list-disc ml-4 mt-1">
              <li>AB ülkeleri için GDPR uyumluluğu zorunludur</li>
              <li>Kaliforniya için CCPA uyumluluğu gereklidir</li>
              <li>Bazı ülkelerde yerel veri saklama gereksinimleri olabilir</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-xl w-[99%] mb-2">
        <div id="platform-requirements">
          <div className="section-header bg-slate-50 border-b-2 border-slate-200 p-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-900">📱 Platform Özel Gereksinimleri</h2>
            <p className="text-gray-600 mt-2">
              Her platformun kendine özgü gereksinimleri vardır. Bu gereksinimleri karşılamak, yayın sürecini
              hızlandırır.
            </p>
          </div>
          <div className="mb-6">
            <div className="mb-6 text-lg">Facebook Gereksinimleri</div>
            <div className="w-full justify-between flex flex-row ">
              <div className="w-[48%]">
                <MyInput
                  value={appDetailsData.facebookAppId}
                  onChange={e => updateAppDetails('facebookAppId', e)}
                  label={'Facebook App Id'}
                  placeholder="Facebook app_id giriniz."
                />
              </div>
              <div className="w-[48%]">
                <MyInput
                  value={appDetailsData.facebookClientToken}
                  onChange={e => updateAppDetails('facebookClientToken', e)}
                  label={'Facebook Client Token'}
                  placeholder="Facebook client_token giriniz."
                />
              </div>
            </div>
          </div>
          <div className="mb-6">
            <div className="mb-6 text-lg">Google Play Gereksinimleri</div>

            <div className="mb-6">
              <div className="flex flex-col  gap-[20px]">
                <Checkbox
                  isSelected={appDetailsData.isAdId}
                  value={appDetailsData.isAdId}
                  onChange={() => updateAppDetails('isAdId', !appDetailsData.isAdId)}
                  color="secondary"
                >
                  <div className="flex items-center">
                    <div>Reklam ID kullanımı</div>
                    <div className="relative group cursor-pointer ml-1">
                      <svg
                        fill="#3A80F6"
                        width="20px"
                        height="20px"
                        viewBox="0 0 12.8 12.8"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title>ionicons-v5-e</title>
                        <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                      </svg>
                      <div className="absolute bottom-full mb-1  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                        Kişiselleştirilmiş reklamlar için gereklidir
                      </div>
                    </div>
                  </div>
                </Checkbox>
                <Checkbox
                  isSelected={appDetailsData.isGooglePlayGameServices}
                  value={appDetailsData.isGooglePlayGameServices}
                  onChange={() =>
                    updateAppDetails('isGooglePlayGameServices', !appDetailsData.isGooglePlayGameServices)
                  }
                  color="secondary"
                >
                  <div className="flex items-center">
                    <div>Google Oyun Hizmetleri</div>
                    <div className="relative group cursor-pointer ml-1">
                      <svg
                        fill="#3A80F6"
                        width="20px"
                        height="20px"
                        viewBox="0 0 12.8 12.8"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title>ionicons-v5-e</title>
                        <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                      </svg>
                      <div className="absolute bottom-full mb-1  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                        Başarılar, lider tabloları veya bulut kaydetme için
                      </div>
                    </div>
                  </div>
                </Checkbox>
              </div>
            </div>
            <div className="mb-6 text-lg">Apple App Store Gereksinimleri</div>

            <div className="mb-6">
              <div className="flex flex-col  gap-[20px]">
                <Checkbox
                  isSelected={appDetailsData.isAtt}
                  value={appDetailsData.isAtt}
                  onChange={() => updateAppDetails('isAtt', !appDetailsData.isAtt)}
                  color="secondary"
                >
                  <div className="flex items-center">
                    <div>App Tracking Transparency (ATT)</div>
                    <div className="relative group cursor-pointer ml-1">
                      <svg
                        fill="#3A80F6"
                        width="20px"
                        height="20px"
                        viewBox="0 0 12.8 12.8"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title>ionicons-v5-e</title>
                        <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                      </svg>
                      <div className="absolute bottom-full mb-1  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                        iOS 14.5+ için kullanıcı izni gereklidir
                      </div>
                    </div>
                  </div>
                </Checkbox>
                <Checkbox
                  isSelected={appDetailsData.isAppleSignInHelp}
                  value={appDetailsData.isAppleSignInHelp}
                  onChange={() => updateAppDetails('isAppleSignInHelp', !appDetailsData.isAppleSignInHelp)}
                  color="secondary"
                >
                  <div className="flex items-center">
                    <div>Apple Sign-In desteği</div>
                    <div className="relative group cursor-pointer ml-1">
                      <svg
                        fill="#3A80F6"
                        width="20px"
                        height="20px"
                        viewBox="0 0 12.8 12.8"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title>ionicons-v5-e</title>
                        <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                      </svg>
                      <div className="absolute bottom-full mb-1  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                        Sosyal giriş varsa zorunludur
                      </div>
                    </div>
                  </div>
                </Checkbox>
              </div>
            </div>

            <div className="info-box mt-8 bg-orange-50 border-l-4 border-orange-500 p-4 text-sm text-slate-600  mb-6">
              <p className="font-medium">⚠️ Apple Özel Gereksinimleri:</p>
              <ul className="list-disc ml-4 mt-1">
                <li>Human Interface Guidelines'a uyum</li>
                <li>In-App Purchase için Apple'ın ödeme sistemini kullanma zorunluluğu</li>
                <li>Harici ödeme sistemlerine yönlendirme yasağı</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <button
        className="mb-6 py-2 px-4 flex items-center justify-center bg-[#7059EF] hover:bg-[#5841D9] rounded text-[#FFFFFF] disabled:bg-[#c5bfff]  cursor-pointer disabled:cursor-not-allowed"
        type="submit"
        ref={appDetailsFormButtonRef}
      >
        Kaydet ve Devam Et
      </button>
    </form>
  );
};

export default AppDetails;

const categories = [
  {
    code: 'Shopping',
    label: 'Alışveriş',
  },
  {
    code: 'Books',
    label: 'Kitaplar',
  },
  {
    code: 'Business',
    label: 'İş',
  },
  {
    code: 'Developer Tools',
    label: 'Geliştirici Araçları',
  },
  {
    code: 'Education',
    label: 'Eğitim',
  },
  {
    code: 'Entertainment',
    label: 'Eğlence',
  },
  {
    code: 'Finance',
    label: 'Finans',
  },
  {
    code: 'Food & Drink',
    label: 'Yiyecek & İçecek',
  },
  {
    code: 'Games',
    label: 'Oyunlar',
  },
  {
    code: 'Graphics & Design',
    label: 'Grafik & Tasarım',
  },
  {
    code: 'Health & Fitness',
    label: 'Sağlık & Fitness',
  },
  {
    code: 'Lifestyle',
    label: 'Yaşam Tarzı',
  },
  {
    code: 'Magazines & Newspapers',
    label: 'Dergiler & Gazeteler',
  },
  {
    code: 'Medical',
    label: 'Tıp',
  },
  {
    code: 'Music',
    label: 'Müzik',
  },
  {
    code: 'Navigation',
    label: 'Navigasyon',
  },
  {
    code: 'News',
    label: 'Haberler',
  },
  {
    code: 'Photo & Video',
    label: 'Fotoğraf & Video',
  },
  {
    code: 'Productivity',
    label: 'Verimlilik',
  },
  {
    code: 'Reference',
    label: 'Referans',
  },
  {
    code: 'Social Networking',
    label: 'Sosyal Ağlar',
  },
  {
    code: 'Sports',
    label: 'Spor',
  },
  {
    code: 'Stickers',
    label: 'Çıkartmalar',
  },
  {
    code: 'Travel',
    label: 'Seyahat',
  },
  {
    code: 'Utilities',
    label: 'Yardımcı Programlar',
  },
  {
    code: 'Weather',
    label: 'Hava Durumu',
  },
];

const ageLimits = [
  {
    code: '5-',
    label: '5 ve altı',
  },
  {
    code: '9-12',
    label: '9-12',
  },
  {
    code: '13-15',
    label: '13-15',
  },
  {
    code: '16-17',
    label: '16-17',
  },
  {
    code: '18 ve üstü',
    label: '18 ve üstü',
  },
];
const countries = [
  {
    code: 'Türkiye — TR',
    label: '🇹🇷 Türkiye — TR',
  },
  {
    code: 'Amerika Birleşik Devletleri — US',
    label: '🇺🇸 Amerika Birleşik Devletleri — US',
  },
  {
    code: 'Fransa — FR',
    label: '🇫🇷 Fransa — FR',
  },
  {
    code: 'Birleşik Krallık — GB',
    label: '🇬🇧 Birleşik Krallık — GB',
  },
];
